import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Correct import for useNavigate
import styles from './modal.module.css';
import { Button, IconButton, Box, TextField, MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Loader from '../Loader';
import * as api from '../../pages/services/api';

export function ModalEditUserStatus({ onClose, initialStatus, id }) {
    const [status, setStatus] = useState(initialStatus || '');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleSave = () => {
        if (status !== initialStatus) {
          save();
        }
        else{
          onClose();
        }
    };

    const save = async () => {
        setLoading(true);
        let res = await api.updateUserStatus(id);
        setLoading(false);
        if (res) {
          if (res['data']['code'] === 200) {
              alert('บันทึกสำเร็จ');
              onClose();
              window.location.reload();
          } else {
              //alert(res['data']['message']);
          }
        } else {
          alert('ไม่ตอบสนอง');
        }
    }

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
      <>
      <Loader loading={loading}/>
        <Box className={styles.backgroundModal}>
          <Box className={styles.boxModal}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gridGap: '10px' }}>
                <Box sx={{ border: '5px solid #478F96' }} />
                <Box sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#478F96',
                  "@media (max-width: 800px)": {
                    fontSize: '16px',
                  }
                }}>แก้ไขสถานะผู้ใช้งาน</Box>
              </Box>
              <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                <IconButton onClick={onClose}>
                  <ClearIcon />
                </IconButton>
              </Box>
            </Box>

            <Box sx={{ display: 'grid', gridGap: '20px' }}>
              <Box>
                <Box>สถานะ</Box>
                <TextField
                  select
                  variant="outlined"
                  fullWidth
                  value={status}
                  onChange={handleStatusChange}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="deactivated">Deactivated</MenuItem>
                </TextField>
              </Box>

              <Button variant='contained' onClick={() => handleSave()} >บันทึก</Button>
            </Box>
          </Box>
        </Box>
      </>
    );
}

export function ModalApproveNewUser({ onClose, uid, fname, lname }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const save = async () => {
        setLoading(true);
        let res = await api.updateUserStatus(uid); /* refer new user data */
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                alert('บันทึกสำเร็จ');
                onClose();
                window.location.reload();
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert('ไม่ตอบสนอง');
        }
    };

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>แจ้งเตือน</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={onClose}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', textAlign: 'center', gridGap: '20px' }}>
                        <Box sx={{
                            fontSize: '16px',
                            "@media (max-width: 800px)": {
                                fontSize: '14px'
                            }
                        }}>
                            ยืนยันการสร้างผู้ใช้งาน '{fname} {lname}' หรือไม่ ?
                        </Box>
                        <Box>
                            <Button
                                variant='contained'
                                onClick={save}
                            >
                                ยืนยัน
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
}
